<template>
  <button @click="handleButton" class="geo-header">
    <svg class="geo-header__svg"
         width="20"
         height="20"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"><path d="M14.209 10.258H11.49c-.744 0-1.348.589-1.348 1.313V13.6c0 .724.604 1.313 1.348 1.313h2.718c.744 0 1.348-.59 1.348-1.313v-2.03c0-.723-.604-1.312-1.348-1.312zm.368 3.342a.364.364 0 0 1-.368.358H11.49a.364.364 0 0 1-.368-.358v-2.03c0-.198.168-.357.368-.357h2.718c.204 0 .368.163.368.358V13.6z" fill="#FF2F00"></path><path d="M20 6.57a.434.434 0 0 0-.065-.235l-2.976-5.092A.495.495 0 0 0 16.535 1H3.46a.487.487 0 0 0-.425.243L.066 6.335A.473.473 0 0 0 0 6.57c0 1.142.707 2.12 1.716 2.554v8.399c0 .262.221.477.49.477H17.79c.27 0 .49-.215.49-.477v-8.34c0-.02 0-.035-.004-.051C19.29 8.698 20 7.716 20 6.57zM3.747 1.959H16.25l2.325 3.982H1.426L3.747 1.96zm10.487 4.933c-.155.86-.928 1.512-1.856 1.512-.927 0-1.7-.653-1.855-1.512h3.71zm-4.753 0c-.155.86-.928 1.512-1.855 1.512-.928 0-1.7-.653-1.86-1.512h3.715zm-8.468 0h3.715c-.155.86-.932 1.512-1.86 1.512-.927.004-1.7-.653-1.855-1.512zM8.24 17.045h-2.82v-5.152c0-.374.31-.68.699-.68h1.426a.69.69 0 0 1 .699.68v5.152h-.004zm9.06 0h-8.08v-5.152c0-.9-.751-1.635-1.68-1.635H6.115c-.924 0-1.68.732-1.68 1.635v5.156H2.697V9.36a2.887 2.887 0 0 0 2.55-1.23 2.887 2.887 0 0 0 2.379 1.234c.989 0 1.86-.49 2.378-1.234a2.885 2.885 0 0 0 2.374 1.234c.99 0 1.86-.49 2.375-1.234a2.887 2.887 0 0 0 2.378 1.234c.057 0 .11-.004.168-.004v7.686zm-.168-8.637c-.928 0-1.7-.653-1.855-1.512h3.715c-.16.855-.932 1.512-1.86 1.512z" fill="#FF2F00"></path></svg>
    <span v-if="canManagerSelectCity" class="geo-header__city-name">{{ computedManagerStoreName || $t('select_your_store') }}</span>
    <span v-else class="geo-header__city-name">{{ computedStaticStoreName }}</span>
  </button>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'UserSelectedShop',
  computed: {
    ...mapGetters(['canManagerSelectCity']),
    ...mapState({
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      managerStore: state => state.checkout.managerStore,
      managerStoreUid: state => state.checkout.managerStoreUid,
      managerType: state => state.user.managerType
    }),
    computedManagerStoreName () {
      if (this.managerStoreUid && this.managerStore?.uid === this.managerStoreUid && this.managerStore?.city.id === this.selectedUserLocation.city_id) {
        return this.managerStore.address
      }

      return null
    },
    computedStaticStoreName () {
      if (this.managerType === this.$constants.MANAGER_TYPE.ACCOUNT_MANAGER) {
        return this.$t('manager_type_account_manager')
      } else if (this.managerType === this.$constants.MANAGER_TYPE.CONTACT_CENTER_MANAGER) {
        return this.$t('manager_type_contact_centre')
      } else if (this.managerType === this.$constants.MANAGER_TYPE.PROFESSIONAL_SEGMENT_MANAGER) {
        return this.$t('manager_type_professional_segment')
      }

      return ''
    }
  },
  methods: {
    handleButton () {
      if (this.canManagerSelectCity) {
        this.$modal.show('user-type-modal')
      }
    }
  }
}
</script>

<style scoped lang="sass">

.geo-header
  padding: 15px 0
  font-family: 'Cera Pro', Roboto, Helvetica, Arial, sans-serif
  border: 0
  background: transparent
  display: flex
  flex-wrap: nowrap
  width: 100%
  align-items: center

  +mmin($tablet--hor)
    padding: 15px

  &:hover
    .geo-header__city-text
      color: $main-color

.geo-header__svg
  margin-right: 10px

.geo-header__city-name
  font-size: 14px
  line-height: 18px
  text-overflow: ellipsis
  white-space: nowrap
  display: block
  overflow: hidden
  color: $text-color
  max-width: 80%

</style>
